import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import React, { Component } from 'react'
import { addURL } from 'redux/actions/url'
import ModalKlaimParticipant from './modalKlaimParticipant/index'
import ModalNoteKlaim from './modalKlaimParticipant/pengajuanNote'

class PengajuanKlaimAktif extends Component {
  constructor(props) {
    super(props)

    this.DatagridRef = React.createRef()
    this.ShowModalAddKlaimRef = React.createRef()
    this.ShowModalEditKlaimRef = React.createRef()
    this.ShowModalNoteRef = React.createRef()

    this.participantId = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.participantId
      : 0
    this.userLoged = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.username
      : ''

    this.columns = [
      {
        type: 'buttons',
        buttons: [
          'edit',
          {
            text: 'Kirim',
            hint: 'edit',
            onClick: (e) => {
              this.ShowModalNoteRef.current.show()
              this.ShowModalNoteRef.current.retrieveData(
                e.row.key,
                this.participantId,
                'kirim'
              )
            },
          },
          {
            text: 'Batal',
            hint: 'edit',
            onClick: (e) => {
              this.ShowModalNoteRef.current.show()
              this.ShowModalNoteRef.current.retrieveData(
                e.row.key,
                this.participantId,
                'batal'
              )
            },
          },
          {
            text: 'Edit',
            hint: 'edit',
            onClick: (e) => {
              this.ShowModalEditKlaimRef.current.show()
              this.ShowModalEditKlaimRef.current.retrieveData(e.row.data)
            },
          },
        ],
      },
      {
        dataField: 'no',
        caption: 'No.',
        cellRender: (e) => {
          return e.rowIndex + 1
        },
      },
      {
        dataField: 'fullName',
        caption: 'Nama Lengkap',
      },
      {
        dataField: 'cardNo',
        caption: 'No. Kartu',
      },
      {
        dataField: 'birthDate',
        caption: 'Tanggal Lahir',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'productName',
        caption: 'Produk Dana Pensiun',
      },
      {
        dataField: 'klaimName',
        caption: 'Tipe Klaim',
      },
      {
        dataField: 'klaimDate',
        caption: 'Tanggal Klaim',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'entryBy',
        caption: 'Input Oleh',
      },
      // {
      //   dataField: 'contact',
      //   caption: 'Kontak',
      //   alignment: 'center',
      //   columns: [
      //     {
      //       dataField: 'mobileNo',
      //       caption: 'Nomor HP',
      //     },
      //     {
      //       dataField: 'email',
      //       caption: 'Email',
      //     },
      //   ],
      // },
    ]
  }

  componentWillMount() {
    let store = this.props.store
    store.dispatch(addURL(this.props.location.pathname))
  }

  onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'plus',
        text: 'Tambah Klaim',
        elementAttr: { class: 'bg-button-add-dapen-default' },
        onClick: (e) => {
          this.ShowModalAddKlaimRef.current.show()
        },
      },
    })
  }

  forceRefresh = () => {
    this.DatagridRef.current.forceRefresh(true)
  }

  render() {
    return (
      <>
        <div className="container-fluid">
          <h2 className="main-title">Pengajuan Klaim Participant</h2>

          <DevExpressDataGrid
            ref={this.DatagridRef}
            loadAPI={`view-pk-klaim-requests?participantId.equals=${this.participantId}`}
            insertAPI="-"
            updateAPI="-"
            deleteAPI="-"
            backendserver={process.env.REACT_APP_BACKEND_CORE}
            remoteOperations={true}
            allowAdding={false}
            allowDeleting={false}
            allowUpdating={false}
            selection={'multiple'}
            showBorders={true}
            paging={true}
            defaultPageSize={10}
            height={'80vh'}
            ColumnChooser={true}
            ColumnFixing={true}
            FilterRow={true}
            ColumnConfiguration={this.columns}
            onToolbarPreparing={this.onToolbarPreparing}
            store={this.props.store}
          />
        </div>

        <ModalKlaimParticipant
          store={this.props.store}
          type="add"
          ref={this.ShowModalAddKlaimRef}
          forceRefresh={this.forceRefresh}
        />
        <ModalKlaimParticipant
          store={this.props.store}
          type="edit"
          ref={this.ShowModalEditKlaimRef}
          forceRefresh={this.forceRefresh}
        />
        <ModalNoteKlaim
          store={this.props.store}
          ref={this.ShowModalNoteRef}
          forceRefresh={this.forceRefresh}
        />
      </>
    )
  }
}

export default PengajuanKlaimAktif
